<div
  class="fixed mx-auto h-full w-full md:bottom-0 md:left-0 md:flex md:flex-col md:items-center md:justify-center mdMax:bottom-0 mdMax:left-0 mdMax:right-0 mdMax:top-0"
  [style.z-index]="index() + 110"
>
  @if (!isMobile()) {
    <app-modal-filler-atom
      [withBackdrop]="true"
      (click)="closeModal.emit($event)"
    ></app-modal-filler-atom>
  }
  <div
    class="flex h-full flex-col overflow-y-auto pb-20 scrollbar-hide md:relative md:my-20 md:max-h-screen md:w-full md:max-w-screen-sm md:rounded-3xl md:pb-0"
    style="max-height: 1021px !important"
    [style.backgroundColor]="backgroundColor() | contentBuilderColor: '#FFFFFF'"
  >
    <div
      id="container"
      class="flex h-full flex-col overflow-y-auto scrollbar-hide md:relative md:max-h-screen md:w-full md:max-w-screen-sm md:pb-0"
      [style.color]="descriptionColor() | contentBuilderColor"
      [style.z-index]="index() + 50"
    >
      <app-back-header-atom
        [text]="title()"
        [icon]="'arrow-left'"
        [isProductHeader]="true"
        [textColor]="headingColor()"
        (click)="closeModal.emit($event)"
      ></app-back-header-atom>
      @if (!hideAdditionGroupDetails()) {
        <div class="px-5 pb-3 pt-6">
          @if (minCount() && !count()) {
            <p class="font-accent text-md font-bold leading-6">
              {{ 'product-add-modal.choose-at-least' | translate }} {{ minCount() }}
            </p>
          } @else if (minCount() && count() && minCount() < count()) {
            <p class="font-accent text-md font-bold leading-6">
              {{ 'product-add-modal.choose-from' | translate }}
              {{ minCount() }} {{ 'product-add-modal.to' | translate }}
              {{ count() }}
            </p>
          }
          @if ((!minCount() && count()) || (minCount() === count() && count())) {
            <p class="font-accent text-md font-bold leading-6">
              {{ 'product-add-modal.choose' | translate }} {{ count() }}
              @if (minCount() === 0) {
                <span>({{ 'product-add-modal.optional' | translate }})</span>
              }
            </p>
          }
          @if (!count() && isAdditionPanel()) {
            <p class="font-accent text-md font-bold leading-6">
              {{ 'product-add-modal.add-additions-hint' | translate }}
            </p>
          }
        </div>
      }

      <div class="flex flex-col gap-1 px-5">
        @for (product of orderedProducts(); track product) {
          @if (!product[productKeys.Hidden]) {
            <label
              [for]="product[productKeys.Id]"
              class="-mx-3 flex cursor-pointer items-center justify-between rounded-lg border p-3 transition-colors hover:border-neutral-300 hover:bg-neutral-100"
              [class.opacity-25]="!isAvailable(product)"
              [class.cursor-not-allowed]="!isAvailable(product)"
              [class.border-neutral-300]="isChecked(product[productKeys.Id])"
              [class.bg-neutral-100]="isChecked(product[productKeys.Id])"
              [class.border-transparent]="!isChecked(product[productKeys.Id])"
            >
              <div class="flex items-center">
                <input
                  type="checkbox"
                  [id]="product[productKeys.Id]"
                  [name]="product[productKeys.Name]"
                  class="form-checkbox mr-3.5 h-5 w-5 border text-primary-600"
                  (change)="toggleCheckbox($event)"
                  [disabled]="!isAvailable(product)"
                  [checked]="isChecked(product[productKeys.Id])"
                />
                <div>
                  <div>
                    <span
                      class="mr-4 inline-flex flex-wrap items-center gap-1 font-base font-normal"
                    >
                      <span>{{ product[productKeys.Name] }}</span>
                      <app-catalog-filter-match-tags
                        [product]="product"
                      ></app-catalog-filter-match-tags>
                    </span>
                    @if (product?.images?.thumbnail?.url) {
                      <div class="flex items-center space-x-4">
                        @if (isChecked(product[productKeys.Id]) && (!count() || count() > 1)) {
                          <div (click)="$event.preventDefault(); $event.stopPropagation()">
                            <app-counter-atom
                              [size]="'S'"
                              [min]="
                                forceType(
                                  product[productKeys.MinCount] ? product[productKeys.MinCount] : 1
                                )
                              "
                              [max]="forceType(product[productKeys.MaxCount])"
                              [disableIncrease]="
                                count() ? (selectedProducts?.length ?? 0) >= count() : false
                              "
                              (countChange)="changeNbProduct($event, product[productKeys.Id])"
                              [count]="calculateNbProduct(product[productKeys.Id])"
                            ></app-counter-atom>
                          </div>
                        }
                        @let uiPrice =
                          product.type === 'SIMPLE'
                            ? product[productKeys.Price]
                            : product[productKeys.Discount] || product[productKeys.Price];
                        @let needToBeFormatted =
                          product.type === 'SIMPLE' ||
                          (!product[productKeys.Discount] && !isAdditionPanel());
                        @if (uiPrice && isAvailable(product)) {
                          <div
                            class="min-w-16.5 pr-1.5"
                            [style.color]="priceColor() | contentBuilderColor"
                          >
                            <span>
                              @if (uiPrice) {
                                <span>+</span>
                              }
                              <app-price-atom
                                [amount]="uiPrice"
                                [bold]="false"
                                [size]="'SM'"
                                [format]="needToBeFormatted"
                              ></app-price-atom>
                            </span>
                          </div>
                        }
                        @if (!isAvailable(product)) {
                          <span> {{ 'product-add-modal.unavailable' | translate }} </span>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              @if (product.images?.thumbnail?.url) {
                <div class="height-fit-content relative bg-neutral-50">
                  @if (product.images?.thumbnail?.url) {
                    <img
                      class="push-image h-full rounded-lg object-cover"
                      [src]="product.images?.thumbnail?.url"
                      alt="image"
                    />
                  }
                </div>
              }
              @if (!product?.images?.thumbnail?.url) {
                <div class="flex items-center space-x-4">
                  @if (isChecked(product[productKeys.Id]) && (!count() || count() > 1)) {
                    <div (click)="$event.preventDefault(); $event.stopPropagation()">
                      <app-counter-atom
                        [size]="'S'"
                        [min]="
                          forceType(
                            product[productKeys.MinCount] ? product[productKeys.MinCount] : 1
                          )
                        "
                        [max]="forceType(product[productKeys.MaxCount])"
                        [disableIncrease]="
                          count() ? (selectedProducts?.length ?? 0) >= count() : false
                        "
                        (countChange)="changeNbProduct($event, product[productKeys.Id])"
                        [count]="calculateNbProduct(product[productKeys.Id])"
                      ></app-counter-atom>
                    </div>
                  }
                  @if (
                    product[productKeys.Price] &&
                    product[productKeys.Price] !== 0 &&
                    isAvailable(product)
                  ) {
                    <div class="min-w-16.5 px-1.5 text-right">
                      @if (!isAdditionPanel()) {
                        <span [style.color]="priceColor() | contentBuilderColor">
                          @if (product[productKeys.Price] > 0) {
                            <span>+</span>
                          }
                          <app-price-atom
                            [amount]="product[productKeys.Price]"
                            [bold]="false"
                            [size]="'SM'"
                            [format]="true"
                          ></app-price-atom>
                        </span>
                      }
                      @if (isAdditionPanel()) {
                        <span [style.color]="priceColor() | contentBuilderColor">
                          @if (product[productKeys.Price] > 0) {
                            <span>+</span>
                          }
                          <app-price-atom
                            [amount]="product[productKeys.Price]"
                            [bold]="false"
                            [size]="'SM'"
                          ></app-price-atom>
                        </span>
                      }
                    </div>
                  }
                  @if (!isAvailable(product)) {
                    <span> {{ 'product-add-modal.unavailable' | translate }} </span>
                  }
                </div>
              }
            </label>
            @if (
              selectedProducts?.includes(product[productKeys.Id]) &&
              visibleAdditionGroups(product).length
            ) {
              <div class="pb-10">
                @for (group of visibleAdditionGroups(product); track group.id) {
                  <div
                    class="border-b border-neutral-300"
                    (click)="openAdditions(product, group.id)"
                  >
                    <div class="flex items-center justify-between bg-neutral-100 px-5 py-4">
                      <div>
                        <p class="mb-0.5 font-accent text-base font-bold">
                          @if (group.min_count > 0 && group.isValid) {
                            <span
                              ><i class="icon icon-check-circle mr-1.5 mt-1 text-success-600"></i
                            ></span>
                          }
                          @if (group.min_count > 0 && !group.isValid) {
                            <span><i class="icon icon-warning-circle mr-1.5 mt-1"></i></span>
                          }
                          {{ group.name }}
                        </p>
                        @if (!hideAdditionGroupDetails()) {
                          @if (
                            group.min_count > 0 &&
                            group.max_count === group.min_count &&
                            !group.isValid
                          ) {
                            <p
                              class="font-base text-sm {{
                                !group.isValid ? 'text-secondary-700' : ''
                              }} leading-5"
                              [style.color]="
                                group.isValid ? (inactiveStateColor() | contentBuilderColor) : ''
                              "
                            >
                              {{ 'product-add-modal.choose' | translate }}
                              {{ group.min_count }}
                            </p>
                          }
                          @if (
                            (group.min_count === 1 || group.min_count > 1) &&
                            group.min_count !== group.max_count &&
                            (group.max_count ?? 0) > 1 &&
                            !group.isValid
                          ) {
                            <p
                              class="font-base text-sm {{
                                !group.isValid ? 'text-secondary-700' : ''
                              }} leading-5"
                              [style.color]="
                                group.isValid ? (inactiveStateColor() | contentBuilderColor) : ''
                              "
                            >
                              {{ 'product-add-modal.choose' | translate }}
                              {{ group.min_count }}
                              {{ 'product-add-modal.to' | translate }}
                              {{ group.max_count }}
                            </p>
                          }
                          @if (
                            group.min_count === 0 && (group.max_count ?? 0) > 0 && !group.isValid
                          ) {
                            <p
                              class="font-base text-sm leading-5"
                              [style.color]="inactiveStateColor() | contentBuilderColor"
                            >
                              {{ 'product-add-modal.choose' | translate }}
                              {{ group.max_count }} max
                            </p>
                          }
                        }
                        @if (group.selectedItems?.length) {
                          <div>
                            @for (item of group.selectedItems; track item; let last1 = $last) {
                              <span class="font-base text-sm font-bold"
                                >{{ item.name }}
                                @if ((item?.quantity ?? 0) > 1) {
                                  <span class="notranslate">x{{ item.quantity }}</span>
                                }
                              </span>
                              @if (!last1) {
                                <span>, </span>
                              }
                            }
                          </div>
                        }
                      </div>
                      <div>
                        <i class="icon icon-arrow-down-s"></i>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          }
        }
      </div>
    </div>
    <footer
      class="fixed bottom-0 mx-auto w-full px-5 py-4 shadow-top md:sticky md:max-w-screen-sm md:px-6"
      [style.backgroundColor]="backgroundColor() | contentBuilderColor: '#FFFFFF'"
    >
      @if (isAdditionPanel()) {
        <app-button-atom
          [disabled]="
            (selectedProducts?.length ?? 0) > count() &&
            (selectedProducts?.length ?? 0) < minCount()
          "
          [type]="'primary'"
          [size]="'L'"
          [label]="'product-add-modal.validate' | translate"
          (click)="closeModal.emit()"
        ></app-button-atom>
      }
      @if (!isAdditionPanel()) {
        <app-button-atom
          [disabled]="checkIfGroupIsNotValid()"
          [type]="'primary'"
          [size]="'L'"
          [label]="'product-add-modal.validate' | translate"
          (click)="onValidate()"
        ></app-button-atom>
      }
    </footer>
  </div>
</div>
